import { convertFileToBase64 } from "../../Providers/DataProvider";;

export const transform = async (data) => {
    if (data.articleImage) {
        const base64Picture = await convertFileToBase64(data.articleImage)
        data.articleImage = {
            src: base64Picture,
            filename: `${data.articleImage.title}`,
        }
    }
    if (data.logoImage) {
        const base64Picture = await convertFileToBase64(data.logoImage)
        data.logoImage = {
            src: base64Picture,
            filename: `${data.logoImage.title}`,
        }
    }
    if (data.resiliationModelAddresses != null && data.resiliationModelAddresses.length > 0) {
        data.resiliationModelAddresses.forEach(element => {
            if (element.id == null || element.id === "") {
                delete element.id;
            } else {
                element.id = parseInt(element.id)
            }

        });
    }
    if (data.resiliationModelUrls != null && data.resiliationModelUrls.length > 0) {
        data.resiliationModelUrls.forEach(element => {
            if (element.id == null || element.id === "") {
                delete element.id;
            } else {
                element.id = parseInt(element.id)
            }

        });
    }
    return data;
}

export const goToWebSite = async (data, dataProvider) => {
    //     var prefecture = data.prefecture;
    //     var servicePrefecture = data.servicePrefecture;
    //     var motifPrefecture = data.motifPrefecture;

    //     if (dataProvider && data?.prefecture && data?.servicePrefecture && data?.motifPrefecture) {
    //         var prefRes = await dataProvider.getOne("Prefectures", prefecture);
    //         prefecture = prefRes.data;
    //         var serviceRes = await dataProvider.getOne("ServicePrefectures", servicePrefecture);
    //         servicePrefecture = serviceRes.data;
    //         var motifRes = await dataProvider.getOne("MotifPrefectures", motifPrefecture);
    //         motifPrefecture = motifRes.data;
    //     }

    //     if (data?.prefecture && data?.servicePrefecture && data?.motifPrefecture) {
    //         const websiteURL = process.env.REACT_APP_WEBSITE_URL
    //         var city = getCityURL(prefecture.city);
    //         var service = getCityURL(servicePrefecture.name);
    //         var motif = getCityURL(motifPrefecture.name);
    //         var fullLink = `${websiteURL}/${city}/${service}/${motif}`
    //         window.open(fullLink, "_blank")
    //     }
}